<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const height = styleOrEmpty(props.height || '24px', 'height');
    const backgroundColor = styleOrEmpty(props.backgroundColor, 'background-color');
    return `<div style="margin:0;line-height:0;font-size:0;${height}${backgroundColor}">&nbsp;</div>`;
};

export default {
    name: 'MailingBlockSpacer',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
